import { android_version, app, ios_version, os } from 'src/stores/session/native-bridge';
import { NativeOperationSystem, type NativeInformation } from './types/init-type';
import { DEFAULT_NATIVE_VERSION } from 'src/constants';
import { checkUser } from 'src/helpers/user_helpers';
import { handleInitialLoad, connectToCloudApi } from '../http';
import { socket_is_connected } from '../socket';
import { web_ready_android } from '../native_container_requests_android';
import { should_go_to, web_ready_ios } from '../native_container_requests_ios';

export const initWeb = () => {
	if (!window.location.pathname.includes('#')) {
		const url = new URL(window.location.href);

		if (url.pathname == '/app-to-app-alexa') {
			url.pathname = '/settings/app-to-app-alexa';
		}

		if (!url.hash) {
			window.location.href = url.origin + '#' + url.pathname + url.search;
		}
	}

	//Attach Window Event Listeners
	window.addEventListener('focus', async () => {
		console.log('[DEBUG] Window focus event');
		// Check socket connection when there is logged in user
		if (checkUser() && !socket_is_connected()) {
			//Reload initial data if socket connection has been lost
			handleInitialLoad();
		}
	});
};

export const initNative = async (os) => {
	if (os === 'IOS') {
		web_ready_ios();
		return;
	}

	// Native `shelly://` commands issued before this handshake are ignored.
	await web_ready_android();
};

export const prepareLocalStorageForOfflineMode = () => {
	if (localStorage.getItem('network')) {
		localStorage.removeItem('network');
		localStorage.removeItem('wifi_ssid');
	}
};

/**
 * This functions will start connection to the server as long as user is logged in.
 *
 * @param os
 * @returns void
 */
export const initServerConnection = (os: NativeOperationSystem) => {
	const isUserLoggedIn = checkUser();

	if (!isUserLoggedIn) {
		setShouldGoToForIos(os);

		return;
	}

	connectToCloudApi().then(() => {
		console.log('[DEBUG] Socket initialization');
		setShouldGoToForIos(os);
	});
};

export const setShouldGoToForIos = (os: NativeOperationSystem) => {
	if (os === NativeOperationSystem.IOS) {
		should_go_to();
	}
};

/**
 * Get native information from user agent and return it as NativeInformation object.
 * This includes whether the app is running in native container, the OS and the version.
 *
 * @returns NativeInformation
 */
export const getNativeInformation = (): NativeInformation => {
	let isApp = navigator.userAgent.match('Shelly') && !navigator.userAgent.match('ShellyStargate');
	let os = NativeOperationSystem.WEB;

	let versions = {
		android: DEFAULT_NATIVE_VERSION,
		ios: DEFAULT_NATIVE_VERSION,
	};

	if (isApp) {
		os = getOperationSystemFromUserAgent();
		versions = getNativeContainerVersion();
	}

	return {
		isApp,
		os,
		versions,
	};
};

const getOperationSystemFromUserAgent = (): NativeOperationSystem => {
	let os = NativeOperationSystem.UNKNOWN;

	try {
		os = navigator.userAgent.split(';')[1].split('-')[0] as NativeOperationSystem;
	} catch (error) {
		os = NativeOperationSystem.WEB;
	}

	return os;
};

const getNativeContainerVersion = () => {
	return {
		android: navigator.userAgent.split('-')[1].split('/')[0] || DEFAULT_NATIVE_VERSION,
		ios: navigator.userAgent.match(/\d+.\d+.\d+/)[0] || DEFAULT_NATIVE_VERSION,
	};
};

export const setNativeInformation = (info: NativeInformation) => {
	os.set(info.os);
	app.set(info.isApp);
	ios_version.set(info.versions.ios);
	android_version.set(info.versions.android);
};
